const initialState = {
  nfts: {
    data: {},
    error: null,
    loaded: false,
  },
  configs: {},
  txs: {
    data: {},
    error: null,
    loaded: false,
  },
  nftsOptimistic: {},
  collectionStats: {},
}

export default initialState
